export const QUESTION_TYPE_OPTIONS = [
  {
    value: 'true',
    label: 'คำนวณ',
  },
  {
    value: 'false',
    label: 'ไม่คำนวณ',
  },
];
